import {HttpClient} from "../../service/httpClient/HttpClient";
import {uploadFile} from "../../service/uploaderService/UploaderService";

export class VersionControlService {

    constructor() {
        this.httpClient = new HttpClient();
    }

    getVersions(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `android-apps`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    createNewVersion(file, name, code, minimumCode, enabled, updateType, description, setProgress, setShowLoadingProgress) {
        return new Promise((resolve, reject) => {
            this.uploadApkFile(
                file,
                setProgress,
                setShowLoadingProgress
            ).then(response => {

                this.httpClient.post(
                    `android-apps`,
                    {
                        title: name,
                        description: description,
                        enabled: enabled,
                        versionNumber: code,
                        mandatory: updateType,
                        apkId: response.id,
                        latestVersionForMandatoryUpdate: minimumCode
                    }
                ).then(resolve).catch(reject)

            }).catch(reject)
        })
    }


    uploadApkFile(file, setProgress, setShowLoadingProgress) {
        return new Promise((resolve, reject) => {
            uploadFile(
                file,
                `apk/files`,
                setProgress,
                () => {
                },
                setShowLoadingProgress,
            ).then(resolve).catch(reject)
        })
    }

    getVersionDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `android-apps/${id}`
            ).then(resolve).catch(reject)
        })
    }

    updateVersion(id, apkId, apkFile, name, versionCode, minimumCode, enabled, updateType, description, setProgress, setShowLoadingProgress) {
        return new Promise((resolve, reject) => {
            if (apkFile) {
                this.uploadApkFile(
                    apkFile,
                    setProgress,
                    setShowLoadingProgress
                ).then(response => {
                    this.handleUpdateApkVersion(
                        id,
                        name,
                        description,
                        enabled,
                        versionCode,
                        updateType,
                        response.id,
                        minimumCode
                    ).then(resolve).catch(reject)
                }).catch(reject)
            } else {
                this.handleUpdateApkVersion(
                    id,
                    name,
                    description,
                    enabled,
                    versionCode,
                    updateType,
                    apkId,
                    minimumCode
                ).then(resolve).catch(reject)
            }
        })
    }


    handleUpdateApkVersion(
        id,
        name,
        description,
        enabled,
        code,
        updateType,
        apkId,
        minimumCode
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `android-apps/${id}`,
                {
                    title: name,
                    description: description,
                    enabled: enabled,
                    versionNumber: code,
                    mandatory: updateType,
                    apkFileId: apkId,
                    latestVersionForMandatoryUpdate: minimumCode
                }
            ).then(resolve).catch(reject)
        })
    }
}